import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/lib/auth";
import BrandLogo from "@/components/marketing/BrandLogo";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const user = await login(email, password);
      toast.success(`Welcome back, ${user.name}`);
      const target = user.role === "super_admin" ? "/admin"
        : !user.onboarded ? "/onboarding" : "/dashboard";
      nav(loc.state?.from || target, { replace: true });
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Login failed");
    } finally { setBusy(false); }
  };

  return (
    <div data-testid="login-page" className="min-h-screen grid lg:grid-cols-2 bg-white">
      <div className="hidden lg:flex flex-col justify-between p-12 bg-[#0F1115] text-white">
        <Link to="/" className="flex items-center gap-2" data-testid="login-logo">
          <BrandLogo size="md" className="text-white" />
        </Link>
        <div>
          <div className="font-mono text-xs text-white/40">// the agent that never sleeps</div>
          <h2 className="font-display font-extrabold text-5xl mt-4 leading-tight">Sign in to your control room.</h2>
          <p className="text-white/60 mt-4">Manage agents, knowledge, calls and conversations from one place.</p>
        </div>
        <div className="font-mono text-xs text-white/40">v0.1 · multi-tenant SaaS</div>
      </div>
      <div className="flex items-center justify-center p-8">
        <form onSubmit={submit} className="w-full max-w-md space-y-5">
          <div>
            <h1 className="font-display font-extrabold text-4xl">Sign in</h1>
            <p className="text-sm text-[#4B5563] mt-2">New here? <Link to="/signup" className="text-[#0044FF] font-medium" data-testid="login-to-signup-link">Create an account</Link></p>
          </div>
          <div>
            <label className="text-sm font-medium block mb-1.5">Email</label>
            <input data-testid="login-email-input" type="email" value={email} onChange={(e)=>setEmail(e.target.value)} required className="w-full border border-[#E2E8F0] focus:border-[#0044FF] focus:ring-2 focus:ring-[#0044FF]/20 outline-none px-3 py-2.5 rounded-sm" />
          </div>
          <div>
            <div className="flex items-center justify-between mb-1.5">
              <label className="text-sm font-medium">Password</label>
              <Link to="/forgot-password" className="text-xs text-[#F97316] font-medium hover:underline" data-testid="login-forgot-password-link">Forgot password?</Link>
            </div>
            <input data-testid="login-password-input" type="password" value={password} onChange={(e)=>setPassword(e.target.value)} required className="w-full border border-[#E2E8F0] focus:border-[#F97316] focus:ring-2 focus:ring-[#F97316]/20 outline-none px-3 py-2.5 rounded-sm" />
          </div>
          <button data-testid="login-submit-button" type="submit" disabled={busy} className="btn-primary w-full disabled:opacity-60">{busy?"Signing in…":"Sign in"}</button>
        </form>
      </div>
    </div>
  );
}
